import { IconAdd } from './Add';
import { IconArrowDown } from './ArrowDown';
import { IconArrowUp } from './ArrowUp';
import { IconBlank } from './Blank';
import { IconCheck } from './Check';
import { IconChevronLeft } from './ChevronLeft';
import { IconChevronRight } from './ChevronRight';
import { IconCross } from './Cross';
import { IconInfo } from './Info';
import { IconQuestionmark } from './Questionmark';
import { IconPendingApproval } from './PendingApproval';
import { IconPendingOne } from './PendingOne';
import { IconPendingTwo } from './PendingTwo';
import { IconPendingThree } from './PendingThree';
import { IconPercent } from './Percent';
import { IconOutgoing } from './Outgoing';
import { IconIncoming } from './Incoming';
import { IconReturn } from './Return';
export const IconCircle = {
    CircleAdd: IconAdd,
    CircleArrowDown: IconArrowDown,
    CircleArrowUp: IconArrowUp,
    CircleBlank: IconBlank,
    CircleCheck: IconCheck,
    CircleChevronLeft: IconChevronLeft,
    CircleChevronRight: IconChevronRight,
    CircleCross: IconCross,
    CircleInfo: IconInfo,
    CircleQuestionmark: IconQuestionmark,
    CirclePendingApproval: IconPendingApproval,
    CirclePendingOne: IconPendingOne,
    CirclePendingTwo: IconPendingTwo,
    CirclePendingThree: IconPendingThree,
    CirclePercent: IconPercent,
    CircleReturn: IconReturn,
    CircleOutgoing: IconOutgoing,
    CircleIncoming: IconIncoming,
};
//# sourceMappingURL=index.js.map